import api from "./api";

const API_BASE_URL = import.meta.env.PROD 
  ? "" 
  : (import.meta.env.VITE_API_URL || "http://localhost:7038").replace(/\/+$/, "");

export const getNewCreations = async () => {
  const response = await api.get("/api/v1/new-creations");
  return response.data?.data || [];
};

export const getCadCams = async () => {
  const response = await api.get("/api/v1/cad-cams");
  return response.data?.data || [];
};

export const getBanners = async () => {
  const response = await api.get("/api/v1/banners");
  return response.data?.data || [];
};

export const getCatalogues = async () => {
  const response = await api.get("/api/v1/catalogues");
  return response.data?.data || [];
};

export const getMediaUrl = (filePath) => {
  if (!filePath || typeof filePath !== "string") {
    return "";
  }

  const trimmedPath = filePath.trim();

  if (/^https?:\/\//i.test(trimmedPath)) {
    return trimmedPath;
  }

  const normalizedPath = trimmedPath
    .replace(/\\/g, "/")
    .replace(/^\/+/, "")
    .replace(/^rowcast/i, "Rowcast")
    .replace(/^cadcam/i, "CadCam")
    .replace(/^catalogues/i, "Catalogues");

  const rootUrl = API_BASE_URL.replace(/\/api\/v1\/?$/, "");

  return encodeURI(`${rootUrl}/${normalizedPath}`);
};

export const getBannerStreamUrl = () => {
  const rootUrl = API_BASE_URL.replace(/\/api\/v1\/?$/, "");
  return `${rootUrl}/api/v1/banners/stream`;
};

export const getNewsEvents = async () => {
  const response = await api.get("/api/v1/news-events");
  return response.data?.data || [];
};

export const getNewsEventBySlug = async (slug) => {
  const response = await api.get(`/api/v1/news-events/slug/${slug}`);
  return response.data?.data || null;
};
